export default {
  path: "/user/cpa/calendario",
  component: () => import("@/views/user/cpa/calendario/CalendarLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
    requiresCpaDirectiva: true,
  },
  children: [
    {
      path: "",
      name: "calendario-dashboard",
      component: () => import("@/views/user/cpa/calendario/CalendarDashboard.vue"),
    },
    {
      path: "nuevo",
      name: "calendario-nuevo",
      component: () => import("@/views/user/cpa/calendario/CalendarEventEditorView.vue"),
    },
    {
      path: ":eventId",
      name: "calendario-editar",
      component: () => import("@/views/user/cpa/calendario/CalendarEventEditorView.vue"),
      props: true,
    },
  ],
};
